import React from "react";
import { Database, Star, Users } from "lucide-react";
import { z } from "zod";

const CardSchema = z.object({
	icon: z.any(),
	title: z.string(),
	description: z.string(),
	gradient: z.string(),
});

const USPsSchema = z.object({
	header: z.string().default("Why Choose PropTechBuzz?"),
	description: z
		.string()
		.default(
			"The complete solution for your BIM projects, from finding the right vendor to building lasting professional relationships."
		),
	cards: z.array(CardSchema).default([
		{
			icon: Database,
			title: "Largest BIM Vendor Directory",
			description: "200+ firms & freelancers across Europe, MENA & beyond.",
			gradient: "from-primary-500 to-primary-600",
		},
		{
			icon: Star,
			title: "Transparent Reviews & Past Work",
			description: "Ratings, case studies, and verified project outcomes.",
			gradient: "from-secondary-500 to-secondary-600",
		},
		{
			icon: Users,
			title: "Architect Community Hub",
			description: "Forums, webinars & peer advice at your fingertips.",
			gradient: "from-accent-500 to-accent-600",
		},
	]),
});

type USPsProps = z.input<typeof USPsSchema>;

const USPs: React.FC<USPsProps> = (props = {}) => {
	const data = USPsSchema.parse(props);

	return (
		<section className="bg-gray-50 py-20">
			<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
				<div className="mb-16 text-center">
					<h2 className="mb-4 text-3xl font-bold text-gray-900 md:text-4xl">{data.header}</h2>
					<p className="mx-auto max-w-3xl text-xl text-gray-600">{data.description}</p>
				</div>

				<div className="grid gap-8 md:grid-cols-3">
					{data.cards.map((card, index) => (
						<div
							key={index}
							className="group rounded-xl bg-white p-8 shadow-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
						>
							<div
								className={`h-16 w-16 rounded-lg bg-gradient-to-r ${card.gradient} mb-6 flex items-center justify-center transition-transform group-hover:scale-110`}
							>
								<card.icon className="h-8 w-8 text-white" />
							</div>
							<h3 className="mb-4 text-xl font-bold text-gray-900">{card.title}</h3>
							<p className="leading-relaxed text-gray-600">{card.description}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default USPs;
